<template>
    <div>
        <h1 class="department-name">{{ currentDepartment.name }}</h1>
        <div class="row" v-if="hasChildren">
            <div class="col-lg-2 col-md-3 col-xs-6" v-for="child in currentDepartment.children" :key="child.id">
                <a href="#" @click="changeSubDepartment(child.slug)" class="thumbnail text-center sub-menu-thumb center-block">
                    <img class="img-responsive" :src="departmentPhoto(child.image)">
                    <h5 class="sub-nav">{{ child.name }}</h5>
                </a>
            </div>
        </div>
        <div v-if="!isGrid">
            <product v-for="product in departmentProducts" :product="product" :key="product.id"> </product>
        </div>
        <div v-else class="row">
            <productGrid v-for="product in departmentProducts" :product="product" :key="product.id"> </productGrid>
        </div>
    </div>
</template>
<script>
    import { getDepartmentProducts } from "../../../api/departments/departments";

    export default {
        data() {
            return {
              selectedSub: {}
            }
        },

        computed: {
            hasChildren() {
                return this.$store.getters.currentDepartmentHasChildren;
            },

            departmentProducts() {
                return (this.currentDepartment.products) ? this.currentDepartment.products : false;
            },

            currentDepartment() {
                return this.$store.getters.currentDepartment;
            },

            isGrid() {
               return (this.currentDepartment.id === 34);
            }
        },

        created() {
            this.getDepartment( );
        },

        methods: {
            async getDepartment() {
                await this.$store.dispatch( 'currentDepartment', this.$route.params.departmentSlug );
                this.selectedSub = this.currentDepartment.child[0];
            },

            departmentPhoto( photo ) {
                return '/storage/departments/' + photo;
            },

          async changeSubDepartment( slug ) {
            this.$store.commit('addProducts', []);
            this.selectedSub = _.find(this.currentDepartment.children, {'slug': slug});
            let departmentProductsResponse = await getDepartmentProducts( slug );
            let products = departmentProductsResponse.data.products;
            this.$store.commit('addProducts', products);
          }
        },

        watch: {
            // call again the method if the route changes
            $route: 'getDepartment'
        }
    };
</script>